export const getFacilitySublimits = (documentId, state) => {
  const facilitySublimits = state.facilities.facilitySublimits[documentId]
    ? state.facilities.facilitySublimits[documentId]
    : [];
  const sublimitsEntities = state.facilities.entities.facilitySublimits
    ? state.facilities.entities.facilitySublimits
    : [];

  const loaded = facilitySublimits && facilitySublimits.loaded ? facilitySublimits.loaded : false;
  const loading = facilitySublimits && facilitySublimits.loading ? facilitySublimits.loading : false;
  const content = loaded ? facilitySublimits.ids.map(id => sublimitsEntities[id]) : [];
  return { content, loading, loaded };
};

export const getFacilitySublimit = (sublimitId, state) => {
  return state.facilities.entities.facilitySublimits[sublimitId];
}

export const getFacilitySublimitFilters = (sublimitId, state) => {
  const facilitySublimitFilters = state.facilities.facilitySublimitFilters[sublimitId]
    ? state.facilities.facilitySublimitFilters[sublimitId]
    : [];
  const sublimitFiltersEntities = state.facilities.entities.facilitySublimitFilters
    ? state.facilities.entities.facilitySublimitFilters
    : [];

  const loaded = facilitySublimitFilters && facilitySublimitFilters.loaded ? facilitySublimitFilters.loaded : false;
  const loading = facilitySublimitFilters && facilitySublimitFilters.loading ? facilitySublimitFilters.loading : false;
  const content = loaded ? facilitySublimitFilters.ids.map(id => sublimitFiltersEntities[id]) : [];
  return { content, loading, loaded };
};

export const getFacilitySublimitFinancingStructureFilters = (sublimitId, state) => {
  const facilitySublimitFinancingStructureFilters = state.facilities.facilitySublimitFinancingStructureFilters[
    sublimitId
  ]
    ? state.facilities.facilitySublimitFinancingStructureFilters[sublimitId]
    : [];
  const sublimitFinancingStructureFiltersEntities = state.facilities.entities.facilitySublimitFinancingStructureFilters
    ? state.facilities.entities.facilitySublimitFinancingStructureFilters
    : [];

  const loaded =
    facilitySublimitFinancingStructureFilters && facilitySublimitFinancingStructureFilters.loaded
      ? facilitySublimitFinancingStructureFilters.loaded
      : false;
  const loading =
    facilitySublimitFinancingStructureFilters && facilitySublimitFinancingStructureFilters.loading
      ? facilitySublimitFinancingStructureFilters.loading
      : false;
  const content = loaded
    ? facilitySublimitFinancingStructureFilters.ids.map(id => sublimitFinancingStructureFiltersEntities[id])
    : [];
  return { content, loading, loaded };
};

export const getFacilityAmount = (documentId, state) => {
  const facility =
    state.facilities.item[documentId] && state.facilities.item[documentId].loaded
      ? state.facilities.entities.facilities[documentId]
      : null;
  const facilityAmount = facility ? facility.facilityAmount : null;
  return { facilityAmount };
};
